import axios from 'axios'
import _ from 'lodash'
import qs from 'query-string'
import core from '../core'

// import { PATH } from './constants'

const {
  constants: { API_URL }, //,
  helpers: { auth }
} = core

const getData = async (queries, names) => {
  const data = await Promise.all(queries)

  const register = data[0].data
  // const persons = data[1].data
  const dataToMap = data[data.length - 1].data

  let dataMapped = {
    register,
    // persons,
    data: dataToMap.map(r => {
      const registerEntry = _.find(register, ['id', r.registerId])
      // const person = _.find(persons, ['id', registerEntry.personId])
      return {
        ...r,
        register: {
          ...registerEntry
          // person: {
          //   ...person
          // }
        }
      }
    })
  }

  names.map((n, i) => {
    if (i > 0 && i < names.length)
      Object.assign(dataMapped, { [n]: data[i].data })
    return n
  })

  return dataMapped
}

const getSupervisionsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/supervisions/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'advices'])

  return dataMapped
}

const getTrainingsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/trainingnames/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/personneltrainings/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'trainingnames',
    'personneltrainings'
  ])

  return dataMapped
}

const getVettingsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/vettings/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'vettings'])

  return dataMapped
}

const getRolesData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/centres/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/roles/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['users', 'centres', 'roles'])

  return dataMapped
}

export const dataFunctions = {
  getRolesData,
  getVettingsData,
  getTrainingsData,
  getSupervisionsData
}

export const getEnrichedRegister = async (
  registerId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  let queryString = {}
  let socialString = {}

  if (registerId && registerId !== 'new') queryString.id = registerId
  socialString.registerId = registerId
  //if (status) queryString.status = status
  //if (type) queryString.type = type
  // if ((await getUserRole()) !== 'admin') {
  //   queryString['audit.createdBy'] = sessionStorage.getItem('user')
  // } else {
  //   if (user && user !== '') queryString['audit.createdBy'] = user
  // }

  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    })
  ]

  if (registerId !== 'new')
    queries.push(
      axios.get(
        `${API_URL}/users/${
          queryString.id //||
            ? // queryString.status ||
              // queryString.type ||
              // queryString['audit.createdBy']
              `?${qs.stringify(queryString)}`
            : ''
        }`,
        {
          headers: { authorization: auth(true) }
        }
      )
    )

  const data = await Promise.all(queries)

  const dataMapped = {
    users: data[0].data
  }

  dataMapped.data =
    registerId !== 'new'
      ? map
        ? data[1].data.map(r => {
            return { ...r, password: undefined }
          })
        : data[1].data
      : []

  return dataMapped
}



// WEBPACK FOOTER //
// ./src/personnel/helpers.js